import React from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  FormGroup,
  Input,
  Collapse,
  Form,
  Label,
  Button,
  Modal,
  ModalBody,
} from "reactstrap";

import CustomButton from "../CustomButton";
import CartTitle from "../CartTitle";
import DesignCard from "../DesignCard";
import get from "lodash/get";
import InputText from "../InputText";
import { useEffect } from "react";

const _ = { get };

const VinLookupDetailPanel = ({
  rowData,
  elements,
  email,
  handleToggleModel,
  handleToggleDocumentsModel,
  handleSetValue,
  handleUserSearch,
  allUser,
  clearReducer,
  clearState,
  allUserStatus,
}) => {
  useEffect(() => {
    clearState();
    clearReducer();
  }, []);

  return (
    <React.Fragment>
      {rowData ? (
        <div className="hideSearch my-3 px-3">
          <Row>
            <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
              <DesignCard
                name={_.get(elements, "vinLookupElement.nameElement", "Name")}
                titleName={`${rowData.userID.fName} ${rowData.userID.lName}`}
              />
            </Col>
            <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
              <DesignCard
                name={_.get(elements, "vinLookupElement.emailElement", "Email")}
                titleName={`${
                  rowData.userID.contactDetails &&
                  rowData.userID.contactDetails.email
                    ? rowData.userID.contactDetails.email
                    : ""
                }`}
              />
            </Col>
            <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
              <DesignCard
                name={_.get(
                  elements,
                  "vinLookupElement.mobileElement",
                  "Mobile"
                )}
                titleName={`${
                  rowData.userID.contactDetails &&
                  rowData.userID.contactDetails.mobile &&
                  rowData.userID.contactDetails.mobile.primary &&
                  rowData.userID.contactDetails.mobile.primary.number
                    ? rowData.userID.contactDetails.mobile.primary.number
                    : ""
                }`}
              />
            </Col>
            <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
              <DesignCard
                name={_.get(elements, "vinLookupElement.vinElement", "VIN")}
                titleName={`${rowData.vin}`}
              />
            </Col>
            <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
              <DesignCard
                name={_.get(
                  elements,
                  "vinLookupElement.modelNameElement",
                  "ModelName"
                )}
                titleName={rowData.vehicleModelName}
              />
            </Col>
            <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
              <DesignCard
                name={_.get(
                  elements,
                  "vinLookupElement.purchaseDateElement",
                  "Purchase Date"
                )}
                titleName={rowData.purchaseDate ? rowData.purchaseDate : "N/A"}
              />
            </Col>
            <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
              <DesignCard
                name={_.get(
                  elements,
                  "vinLookupElement.registrationNoElement",
                  "Registration No"
                )}
                titleName={
                  rowData.registrationNo ? rowData.registrationNo : "N/A"
                }
              />
            </Col>
          </Row>

          <Row>
            <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
              <InputText
                labelName={_.get(
                  elements,
                  "vinLookupElement.transferEmailLabel",
                  "Transfer of Ownership: Enter Email ID"
                )}
                inputType={"text"}
                inputName={"email"}
                InputClass={"inputText mb-0"}
                inputPlaceholder={_.get(
                  elements,
                  "vinLookupElement.emailPlaceholder",
                  "Email"
                )}
                customValue={email}
                customOnChange={(e) => handleSetValue(e)}
              />
            </Col>
            <Col xl={3} lg={4} md={6} sm={6}>
              <div className="d-flex align-item-start button_LeftSide mt-0 mt-md-4 mb-2 pt-1">
                <CustomButton
                  customType={"button"}
                  name={_.get(
                    elements,
                    "vinLookupElement.searchUserButtonElement",
                    "Search User"
                  )}
                  customClass={"btn-outline-dark bg-none btnthemeColor mt-1 "}
                  customClick={() => handleUserSearch()}
                />
              </div>
            </Col>
          </Row>

          {allUser.length ? (
            <>
              <Row>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
                  <DesignCard
                    name={_.get(
                      elements,
                      "vinLookupElement.firstnNameElement",
                      "First name"
                    )}
                    titleName={allUser[0].fName}
                  />
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
                  <DesignCard
                    name={_.get(
                      elements,
                      "vinLookupElement.lastNameElement",
                      "Last name"
                    )}
                    titleName={allUser[0].lName}
                  />
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
                  <DesignCard
                    name={_.get(
                      elements,
                      "vinLookupElement.emailElement",
                      "Email"
                    )}
                    titleName={allUser[0].contactDetails.email}
                  />
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
                  <DesignCard
                    name={_.get(
                      elements,
                      "vinLookupElement.phoneElement",
                      "Phone"
                    )}
                    titleName={allUser[0].contactDetails.mobile.primary.number}
                  />
                </Col>
                <Col>
                  <div className="d-flex justify-content-start justify-content-md-end">
                    <CustomButton
                      name={_.get(
                        elements,
                        "vinLookupElement.transferOwnershipButtonElement",
                        "Transfer Ownership"
                      )}
                      customClass={"btn-outline-dark bg-none btnthemeColor"}
                      customClick={() => handleToggleModel()}
                    />
                  </div>
                </Col>
              </Row>
            </>
          ) : (
            !allUserStatus && (
              <h5 className="text-center font-weight-bold">
                {_.get(
                  elements,
                  "vinLookupElement.noUserFoundElement",
                  "No user found"
                )}
              </h5>
            )
          )}
        </div>
      ) : null}
    </React.Fragment>
  );
};

export default VinLookupDetailPanel;
